// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchTraining_wrapper__OX3UR","selectLang":"SearchTraining_selectLang__lh2lK"};